import moment from "moment";
import { useState } from "react";
import { Numeral } from "../../../../components/Numeral";
import { INftAssetTrxHistory } from "../../../../interfaces"

interface NftDetailHistoryProps {
  nftTrxHistories: INftAssetTrxHistory[] | null;
}
export const NftDetailHistory = ({ nftTrxHistories }: NftDetailHistoryProps) => {
  const [expand, setExpand] = useState<Boolean>(true);
  return (
    <>
      <div className="d-flex justify-content-between align-items-center p-3 cursor-pointer" onClick={() => {
        setExpand(!expand);
      }}>
        <div className="">
          <span className="material-icons mr-2" style={{ verticalAlign: 'bottom', }}>history</span>
          <span className="weight-600">價格歷史</span>
        </div>
        <span className="material-icons-outlined text-gray-400">{expand ? 'expand_less' : 'expand_more'}</span>
      </div>
      <div
        className="bg-gray-50 border-up txt-14 text-justify overflow-x-auto"
        style={{ height: expand ? 'auto' : '0px' }}
      >
        <table className="table mb-0" style={{ minWidth: '500px' }}>
          <thead className="bg-white">
            <tr>
              <th style={{ textAlign: 'left' }}>事件</th>
              <th style={{ textAlign: 'left' }}>價格</th>
              <th style={{ textAlign: 'left' }}>From</th>
              <th style={{ textAlign: 'left' }}>To</th>
              <th style={{ textAlign: 'left' }}>日期</th>
            </tr>
          </thead>
          <tbody>
            {
              nftTrxHistories?.map((nftTrxHistory, index) => {
                return (
                  <tr key={nftTrxHistory.idNftTrxHistory}>
                    {index === nftTrxHistories.length - 1 && <td className="py-3" style={{ textAlign: 'left' }}><span className="material-icons mr-2" style={{ verticalAlign: 'bottom', }}>tips_and_updates</span>創作</td>}
                    {index < nftTrxHistories.length - 1 && <td className="py-3" style={{ textAlign: 'left' }}><span className="material-icons mr-2" style={{ verticalAlign: 'bottom', }}>cached</span>轉移</td>}
                    <td className="py-3" style={{ textAlign: 'left' }}><Numeral value={nftTrxHistory.buyingPrice} /></td>
                    <td className="py-3">{index < nftTrxHistories.length - 1 ? nftTrxHistory.fromProfile.nickname || nftTrxHistory.fromProfile.simpleCode : nftTrxHistory.toProfile.simpleCode}</td>
                    <td className="py-3">{nftTrxHistory.toProfile.nickname || nftTrxHistory.toProfile.simpleCode}</td>
                    <td className="py-3">{moment(nftTrxHistory.generatedTimestamp).format('YYYY-MM-DD')}</td>
                  </tr>
                )
              })
            }
          </tbody>
        </table>

      </div>
    </>
  )
}